import produce from 'immer';

// Action types
import {
  CLOSE_VERIFIED_TOOLTIP
} from 'constants/actionTypes';

// Default State
// ------------------------------------------------------- //
const initialState = {
  requesting: false,
  visibility: {
    verifiedTooltip: true
  }
};

// Reducers
// ------------------------------------------------------- //
export const visibilityReducer = produce((draft, action) => {
  switch (action.type) {
    case CLOSE_VERIFIED_TOOLTIP:
      draft.verifiedTooltip = false;
      return;
    default:
  }
}, initialState);

export default visibilityReducer;

// Action Creators
// ------------------------------------------------------- //
export const closeVerifiedTooltip = payload => ({
  type: CLOSE_VERIFIED_TOOLTIP,
  payload
});



// WEBPACK FOOTER //
// ./src/store/modules/app/visibility/visibilityReducer.js